import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/services/utils.service';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { PlanRequestModalService } from './plan-request-modal.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-plan-request-modal',
  templateUrl: './plan-request-modal.component.html',
  styleUrls: ['./plan-request-modal.component.css']
})
export class PlanRequestModalComponent implements OnInit {

  planReqtableDatasource: any[];
  planReqtableConfigs: object;
  planReqtableColumnConfigs: any[];
  gridCallBacks: object = {};

  constructor(public config: DynamicDialogConfig,
              private utils: Utils,
              private httpService: HttpRequestService,
              public ref: DynamicDialogRef,
              private planRequestModalService: PlanRequestModalService) { }

  fetchRequestDetails(selectedList) {
    const reqData = {
      strPlanNo: selectedList['PLAN_NO'],
      strReqNo: selectedList['REQUEST_NO']
    };
    const requestData = this.utils.constructRequestData(reqData, 'CorePlanningService', 'requestPlanView');

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response: any) => {
        const gridSource = response['grid_array'];
        this.planReqtableDatasource = this.utils.findAndSetGridSource(gridSource, 'Requestplanview');
        this.planReqtableConfigs = this.planRequestModalService.gridConfigs(this);
        this.planReqtableColumnConfigs = this.planRequestModalService.getRequestModalColumnConfigs();
      });
  }

  onClose() {
    this.ref.close();
  }

  ngOnInit() {
    this.fetchRequestDetails(this.config.data['requestDetails']);
  }
}                 
